<template>
    <div v-if="!disableEdit">
        <v-radio-group
                v-model="formData.taxRegistered"
                :error-messages="taxRegisteredErrors"
                @input="$v.formData.taxRegistered.$touch()"
                @blur="$v.formData.taxRegistered.$touch()"
        >
            <div slot="label">Are you VAT/TVA/IVA registered?</div>
            <v-radio label="Yes" value="yes"></v-radio>
            <v-radio label="No" value="no"></v-radio>
        </v-radio-group>
        <v-text-field
                v-model="formData.taxNumber"
                label="Tax Number"
                :required="taxNumberRequired"
                :error-messages="taxNumberErrors"
                @input="$v.formData.taxNumber.$touch()"
                @blur="$v.formData.taxNumber.$touch()"
        ></v-text-field>
    </div>
    <p v-else>UK companies are not required to provide their tax information. VAT will automatically be applied to your order
        before checkout.</p>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'
  import {required, requiredIf} from 'vuelidate/lib/validators'


  // tax_number = wtforms.fields.StringField(_('VAT/TVA/IVA Number'), [TaxRegisteredValidation])
  // not_tax_registered = wtforms.fields.BooleanField(_('We are not VAT/TVA/IVA registered'), [])
  export default {
    name: 'TaxFields',
    mixins: [FieldsMixin],
    data: () => ({
      formData: {
        taxNumber: null,
        taxRegistered: null
      },
      disabledDefaultData: {
        taxRegistered: 'no',
        taxNumber: null
      }
    }),
    validations: {
      formData: {
        taxRegistered: {
          required
        },
        taxNumber: {
          required: requiredIf(function () {
            return this.formData.hasOwnProperty('taxRegistered') && this.formData.taxRegistered === 'yes'
          }),
        }
      }
    },
    computed: {
      taxNumberRequired () {
        return this.formData.hasOwnProperty('taxRegistered') && this.formData.taxRegistered === 'yes'
      },
      taxRegisteredErrors () {
        const errors = []
        if (!this.$v.formData.taxRegistered.$dirty) return errors
        !this.$v.formData.taxRegistered.required && errors.push('Please specify whether you are VAT/TVA/IVA registered.')
        return errors
      },
      taxNumberErrors () {
        const errors = []
        if (!this.$v.formData.taxNumber.$dirty) return errors
        !this.$v.formData.taxNumber.required && errors.push('Tax number is required if you are VAT/TVA/IVA registered.')
        return errors
      }
    },
    methods: {
      preInitialValidationHook () {
        const validChoices = ['yes', 'no']
        // This method only gets called if there is an initial value passed, so we simply check if the registered value is set
        if (validChoices.indexOf(this.formData.taxRegistered) === -1) {
          if (this.formData.taxNumber) {
            this.formData.taxRegistered = 'yes'
          } else {
            this.formData.taxRegistered = 'no'
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
